import { render, staticRenderFns } from "./WorkStationEdit.vue?vue&type=template&id=765b23c1"
import script from "./WorkStationEdit.vue?vue&type=script&lang=js"
export * from "./WorkStationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports